import React from 'react'

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-6 text-start">
            <p className="mb-0 text-muted fw-bold">
              HDL Technology

            </p>
          </div>
          <div className="col-6 text-end">
            <ul className="list-inline">

             <ul className="list-inline">
              <li className="list-inline-item">
                <span className="text-muted fw-bold small">V. 2.0.1</span>
              </li> 
            </ul>
            </ul>
          </div>
        </div>
      </div>
    </footer>

  )
}
